<template>
  <div>
    <div class="my-4 mx-1">
      <el-row>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
            >管理中心</el-breadcrumb-item
          >
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/admin/user/role' }"
            >角色列表</el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span class="text-primary">新增角色</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </el-row>
      <el-card class="my-4 mx-1">
        <div slot="header">
          <span class="font-weight-bold text-primary">新增角色</span>
        </div>
        <el-form
          class="font-weight-bold w-50"
          label-width="120px"
          :model="roleInfo"
        >
          <el-form-item label="中文名称">
            <el-input v-model="roleInfo.nameZh"></el-input>
          </el-form-item>
          <el-form-item label="英文名称">
            <el-input v-model="roleInfo.name"></el-input>
          </el-form-item>
          <el-form-item label="角色描述">
            <el-input v-model="roleInfo.roleDesc"></el-input>
          </el-form-item>

          <el-form-item label="菜单配置" prop="menus">
            <el-tree
              :data="menus"
              :props="menusProps"
              show-checkbox
              :default-checked-keys="selectedMenusIds"
              node-key="menuId"
              ref="menuTree"
            >
            </el-tree>
          </el-form-item>

          <el-form-item label="功能配置" prop="perms">
            <el-tree
              :data="perms"
              :props="permsProps"
              show-checkbox
              :default-checked-keys="selectedPermsIds"
              node-key="permissionId"
              ref="permTree"
            >
            </el-tree>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitAddRoleForm(roleInfo)"
              >立即提交</el-button
            >
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddRole",
  data() {
    return {
      roleInfo: {},
      perms: [],
      menus: [],
      selectedPermsIds: [],
      selectedMenusIds: [],
      menusProps: {
        id: "menuId",
        label: "nameZh",
        children: "children"
      },
      permsProps: {
        id: "permissionId",
        label: "permissionDesc",
        children: "children"
      }
    };
  },
  mounted() {
    this.listPerms();
    this.listMenus();
  },
  methods: {
    listPerms() {
      this.axios.get("/adminPermission/listAllPermissions").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.perms = resp.data.data;
        }
      });
    },
    listMenus() {
      this.axios.get("/adminMenu/listAllMenus").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.menus = resp.data.data;
        }
      });
    },
    cancelSubmitForm() {
      this.$router.push({ name: "Role" }).catch();
    },
    submitAddRoleForm(roleInfo) {
      this.axios
        .post("/adminRole/admin/addRole", {
          name: roleInfo.name,
          nameZh: roleInfo.nameZh,
          roleDesc: roleInfo.roleDesc,
          menus: this.$refs.menuTree
            .getCheckedKeys()
            .concat(this.$refs.menuTree.getHalfCheckedKeys()),
          perms: this.$refs.permTree
            .getCheckedKeys()
            .concat(this.$refs.permTree.getHalfCheckedKeys())
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: resp.data.message,
              type: "success"
            });
            // 修改角色后返回角色列表界面
            this.$router.push({ name: "Role" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: resp.data.msg
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
